import { createRoot } from 'react-dom/client';
import App from './App';
import { RecoilRoot } from 'recoil';
import Footer from '@/components/common/elements/Footer';
import axios from "axios";
import { initNativeApp } from '@/native/capacitorApp';
import { installChunkReload } from '@/common/chunkReload';
import AppErrorBoundary from '@/components/common/AppErrorBoundary';

axios.defaults.withCredentials = true;
initNativeApp();
installChunkReload();
const domNode = document.getElementById('root') as HTMLElement;
const root = createRoot(domNode);
root.render(
        <AppErrorBoundary>
            <RecoilRoot>
                <App />
            </RecoilRoot>
        </AppErrorBoundary>,
);
